import { render, staticRenderFns } from "./OrderedProducts.vue?vue&type=template&id=11b5cfa3&scoped=true&"
import script from "./OrderedProducts.vue?vue&type=script&lang=js&"
export * from "./OrderedProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b5cfa3",
  null
  
)

export default component.exports